import { options } from './options';

export const filterBar = ($http: HttpApi) => ({
  options: options($http),
});
